import React, { useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import useFeatureFlag from "../../../hooks/useFeatureFlag";
import { restrictedIntegrations } from "../../../axios/constant";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import SharedDataContext from "../../../SharedDataContext";
import { getIntegrations } from "../../../apis/ext";
import { Skeleton } from "../../ui/skeleton";
import Image from "../../Tags/Image";

export default function Integrations() {
  const isPremiumProvidersEnabled = useFeatureFlag("enable-premium-providers");
  const isAdvancePhoneVerificationEnabled = useFeatureFlag("advanced-phone-verification");
  const captureEvent = useCaptureEvent();
  const { userData } = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};
  const [integrations, setIntegrations] = useState({});
  const [installedIntegrations, setInstalledIntegrations] = useState([]);

  const getIntegrationsFn = useQuery(
    "get_integrations",
    () => {
      return getIntegrations({
        options: {
          headers: {
            "X-Workspace-Id": activeWorkspace?.id,
          },
        },
      });
    },
    {
      enabled: !!activeWorkspace,
      refetchOnWindowFocus: false,
      manual: true,
      onSuccess: (data) => {
        const newData = data;
        newData.available.forEach((availApp) => {
          const isInstalled = newData.installed.some((instApp) => instApp.integration.key === availApp.key);
          if (isInstalled) {
            availApp.installed = true;
          }
        });
        setIntegrations(newData);
      },
      onError: (error) => {
        console.error(error);
      },
    }
  );

  const handleGetIntegrations = () => {
    getIntegrationsFn.refetch();
  };

  useEffect(() => {
    if (activeWorkspace?.id) {
      handleGetIntegrations();
    }
  }, [activeWorkspace]);

  if (getIntegrationsFn.isFetching) {
    return (
      <div className="flex flex-col space-y-3">
        <Skeleton className="h-[225px] w-full rounded-xl" />
        <Skeleton className="h-[225px] w-full rounded-xl" />
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {integrations &&
        integrations.available &&
        integrations.available.length > 0 &&
        integrations.available
          .filter((integration) => {
            if (restrictedIntegrations.includes(integration.key)) {
              return isPremiumProvidersEnabled;
            }
            if (integration.key === "advanced_phone_verification") {
              return isAdvancePhoneVerificationEnabled;
            }
            return true;
          })
          .map((integration) => (
            <div
              className="border border-border rounded-[14px] overflow-hidden bg-background"
              key={integration.key}
            >
              <div className="flex p-3 justify-between items-center border-b border-border">
                <div className="flex items-center">
                  <span
                    className="integration__svg__logo"
                    dangerouslySetInnerHTML={{ __html: integration.logo }}
                  />
                  <span className="text-[16px] text-gray-900 ml-2">{integration.display_name}</span>
                </div>
              </div>
              <div className="py-4 px-4 border-b border-gray-300 ">
                <div>
                  <span className="text-[12px] block mt-1">{integration.description}</span>
                </div>
              </div>
              <div className="flex p-3 justify-between items-center">
                <div>
                  {integration.installed ? (
                    <a
                      target="_blank"
                      href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace.slug}/settings/integrations?tab=integrations&manage=${integration?.key}`}
                      className="text-size-[14px] py-1 px-4 rounded-lg text-purple-700 bg-brand-50 inline-flex items-center"
                      onClick={() => {
                        captureEvent("EXU_Integrations_ManageBtn");
                      }}
                    >
                      <Image src="/images/ext/settings-purple.svg" alt="Settins" className="mr-2 no-invert" /> Manage
                    </a>
                  ) : (
                    <a
                      target="_blank"
                      href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace.slug}/settings/integrations?tab=integrations&connect=${integration?.key}`}
                      className="text-size-[14px] py-1 px-4 rounded-lg text-blue-600 bg-blue-50 inline-flex items-center"
                      onClick={() => {
                        captureEvent("EXU_Integrations_InstallBtn");
                      }}
                    >
                      <Image src="/images/ext/play.svg" alt="Instal" className="mr-2 no-invert" /> Install
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
    </div>
  );
}
